import * as FaIcons from 'react-icons/fa';
import moment from "moment";

export const combineAddress = (data) => {

  const defaultAddressKeys = ["address1", "address2", "city", "state", "country", "postalcode"]
  let addressData = []

  for (const key of Object.keys(data)) {
    if (defaultAddressKeys.includes(key)) {
      if (data[key]) { addressData.push(data[key]) }
    }
  }
  return addressData.join(", ")

}

export const getAuthHeader = () => {
  return { 'authorization': `Bearer ${JSON.parse(localStorage.getItem('user')).accessToken}` }
}

export const getTime = (start_time, stop_time, action_history) => {
  if (!start_time) return { time: "", hoursLogged: "0s" };

  const currentTime = new Date();
  const startDate = new Date(start_time);

  let elapsedTime = 0;
  let totalPausedTime = 0;
  let lastPause = null;
  let latestStop = null;
  let isPaused = false;
  let hasResume = false;

  const action = Array.isArray(action_history) ? action_history : [];
  action?.forEach((action) => {
    const actionTime = new Date(action.time);
    if (action.action === "pause") {
      lastPause = actionTime;
      isPaused = true;
    }
    else if (action.action === "resume" && lastPause) {
      totalPausedTime += actionTime - lastPause;
      lastPause = null;
      isPaused = false;
      hasResume = true;
    }
    else if (action.action === "stop") {
      latestStop = actionTime;
    }

  });


  if (!hasResume && lastPause && latestStop) {
    totalPausedTime += latestStop - lastPause;
  }
  if (latestStop) {
    elapsedTime = latestStop - startDate - totalPausedTime;
  }
  else if (isPaused && lastPause) {
    elapsedTime = lastPause - startDate - totalPausedTime;
  }
  else {
    elapsedTime = currentTime - startDate - totalPausedTime;
  }

  const diffSeconds = Math.floor(elapsedTime / 1000);
  const hh = String(Math.floor(diffSeconds / 3600));
  const mm = String(Math.floor((diffSeconds % 3600) / 60));
  const ss = String(diffSeconds % 60);
  const time = `${hh}:${mm}:${ss}`;

  const hoursLogged = latestStop ? `${hh}h ${mm}m ${ss}s` : "";
  return { time, hoursLogged };
};

export const iconMap = {
  Trophy: FaIcons.FaTrophy,
  Medal: FaIcons.FaMedal,
  TeamWork: FaIcons.FaHandshake,
  Award: FaIcons.FaAward,
};

export const getIconComponent = (iconName) => {
  return iconMap[iconName] || null;
};

export const generateYearOptions = () => {
  const currentYear = new Date().getFullYear();
  const years = [];
  for (let i = 4; i >= 0; i--) {
    const year = currentYear - i;
    years.push({
      value: year.toString(),
      label: year.toString()
    });
  }
  return years;
};

export const Month = [
  { value: 'January', label: 'January' },
  { value: 'February', label: 'February' },
  { value: 'March', label: 'March' },
  { value: 'April', label: 'April' },
  { value: 'May', label: 'May' },
  { value: 'June', label: 'June' },
  { value: 'July', label: 'July' },
  { value: 'August', label: 'August' },
  { value: 'September', label: 'September' },
  { value: 'October', label: 'October' },
  { value: 'November', label: 'November' },
  { value: 'December', label: 'December' },
];

const currentYear = new Date().getFullYear();
const startYear = 2019;
export const Year = Array.from({ length: currentYear - startYear + 1 }, (_, i) => {
  const year = (currentYear - i).toString();
  return { value: year, label: year };
});

export const Department = [
  { value: 'all', label: 'all' },
  { value: 'design ', label: 'design ' },
  { value: 'development', label: 'development' },
  { value: 'intern', label: 'intern' },
  { value: 'full stack', label: 'full stack' },
  { value: 'frontend', label: 'frontend' },
  { value: 'backend', label: 'backend' },
  { value: 'team leader', label: 'team leader' },
  { value: 'hr', label: 'hr' },
]

export const activityStyles = {
  'Clock In': {
    dotColor: '#22C55E',
    backgroundColor: '#D7F3E2',
  },
  'Clock Out': {
    dotColor: '#F44336',
    backgroundColor: '#FDE1DF',
  },
  'Start Timer': {
    dotColor: '#00ACC1',
    backgroundColor: '#D6F2F5',
  },
  'Pause Timer': {
    dotColor: '#1E88E5',
    backgroundColor: '#DBECFB',
  },
  'Stop Timer': {
    dotColor: '#5E35B1',
    backgroundColor: '#E5DFF3',
  },
  'On Leave': {
    dotColor: '#FFE87C',
    backgroundColor: '#EDDCF1',
  },
  'Apply Leave': {
    dotColor: '#FF9800',
    backgroundColor: '#FFEFD6',
  },
  'Reject Leave': {
    dotColor: '#F600FF',
    backgroundColor: '#FED6FF',
  },
  'Approve Leave': {
    dotColor: '#6D4C41',
    backgroundColor: '#E8E2E1',
  },
  'Delete Leave': {
    dotColor: '#000000',
    backgroundColor: '#D6D6D6',
  },
  'Create Task': {
    dotColor: '#8E24AA',
    backgroundColor: '#EDDCF1',
  },
  'Complete Task': {
    dotColor: '#B0BEC5',
    backgroundColor: '#F2F5F6',
  },
};

export const activityFilter = [
  'Clock In',
  'Clock Out',
  'Start Timer',
  'Pause Timer',
  'Stop Timer',
  'On Leave',
  'Apply Leave',
  'Reject Leave',
  'Approve Leave',
  'Delete Leave',
  'Create Task',
  'Complete Task',
];

export const projectActivity = [
  'Start Timer',
  'Pause Timer',
  'Stop Timer',
  'Create Task',
  'Complete Task',
];

export const getSundaysInMonth = (year, month) => {
  const sundays = [];
  const daysInMonth = moment(`${year}-${month}`, 'YYYY-MM').daysInMonth();

  for (let day = 1; day <= daysInMonth; day++) {
    const date = moment(`${year}-${month}-${day}`, 'YYYY-MM-DD');
    if (date.day() === 0) {
      sundays.push({
        date: date.format('YYYY-MM-DD'),
        occasion: 'Sunday',
        fromDb: false
      });
    }
  }
  return sundays;
};
export const getAlternateSaturdaysInMonth = (year, month) => {
  const alternates = [];
  const startDate = moment('2025-01-04', 'YYYY-MM-DD');
  const monthStart = moment(`${year}-${month}-01`, 'YYYY-MM-DD');
  const monthEnd = monthStart.clone().endOf('month');

  let altDate = startDate.clone();
  while (altDate.isBefore(monthStart)) {
    altDate.add(2, 'weeks');
  }

  while (altDate.isSameOrBefore(monthEnd)) {
    if (altDate.day() === 6) {
      alternates.push({
        date: altDate.format('YYYY-MM-DD'),
        occasion: 'Week off',
        fromDb: false
      });
    }
    altDate.add(2, 'weeks');
  }
  return alternates;
};

export const getDateRange = (filterType) => {
 let startDate, endDate;

  switch (filterType) {
    case 'Today':
      startDate = moment().subtract(0, 'days').startOf('day').toDate(); 
       endDate = moment().endOf('day').toDate();
      break;
    case 'Yesterday':
      startDate = moment().subtract(1, 'days').startOf('day').toDate(); 
      endDate = moment().subtract(1, 'days').endOf('day').toDate();
      break;
    case 'Last 7 Days':
      startDate = moment().subtract(7, 'days').startOf('day').toDate(); // 7 days ago
      endDate = moment().subtract(1, 'days').endOf('day').toDate(); // Until yesterday
      break;
    case 'Last 14 Days':
       startDate = moment().subtract(14, 'days').startOf('day').toDate();
      endDate = moment().subtract(1, 'days').endOf('day').toDate();
      break;
    case 'Last 30 Days':
    startDate = moment().subtract(30, 'days').startOf('day').toDate();
      endDate = moment().subtract(1, 'days').endOf('day').toDate();
      break;
    case 'Last 3 Months':
     startDate = moment().subtract(3, 'months').startOf('day').toDate();
      endDate = moment().subtract(1, 'days').endOf('day').toDate();
      break;
    case 'Last 12 Months':
      startDate = moment().subtract(12, 'months').startOf('day').toDate();
      endDate = moment().subtract(1, 'days').endOf('day').toDate();
      break;
    case 'Custom':
      return { startDate: null, endDate: null };
    default:
      return { startDate: null, endDate: null };
  }
  return { startDate, endDate };
};